<template>
  <!--eslint-disable-->
  <v-dialog persistent v-model="checklistDialog" max-width="50%" height="70vh">
    <v-card flat>
      <v-toolbar flat dark sticky color="primary" elevation="0">
        <v-toolbar-title class="text-lg-h6 mx-auto d-flex mt-3">
          <p v-if="programme" class="mr-2">{{ programme.code }}</p>
          Checklist
        </v-toolbar-title>
      </v-toolbar>
      <v-skeleton-loader
        v-if="!programme"
        type="list-item-two-line, table-thead, table-tbody, table-row-divider, actions"
      />
      <div v-else>
        <v-divider />
        <!-- <div v-if="!programme">
        <v-progress-circular
          indeterminate
          color="primary"
          :size="70"
          :width="7"
          class="mx-auto"
        />
      </div> -->

        <v-card-text class="font">
          <ul>
            <li>
              The list below contains requirements a student needs to complete
              to gain admittance.
            </li>
            <li>
              Some checklist items can be set as mandatory where the application
              will not show as completed until they are met.
            </li>
          </ul>
        </v-card-text>

        <v-card-text
          class="overflow-y-auto overflow-x-hidden"
          style="max-height: 70vh"
        >
          <v-data-table
            v-if="programme"
            :headers="headers"
            :items="programme.checklist"
            hide-default-footer
          >
            <template v-slot:item.id="{ index }">
              <span>{{ index + 1 }}</span>
            </template>
            <template v-slot:item.mandatory="{ item }">
              <div v-if="item.mandatory">
                <v-icon color="primary">mdi-check-circle</v-icon>
              </div>
              <div v-else>
                <v-icon class="warning">mdi-alpha-x</v-icon>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn outlined v-on:click="setChecklistDialog = false" color="error">
            close
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ApplicationChecklist",
  data: function () {
    return {
      headers: [
        {
          text: "Type",
          sortable: true,
          value: "checkListType",
          align: "center",
        },
        {
          text: "Description",
          sortable: true,
          value: "description",
          align: "center",
        },
        {
          text: "Service Type",
          sortable: true,
          value: "serviceType",
          align: "center",
        },
        {
          text: "Mandatory",
          sortable: true,
          value: "mandatory",
          align: "center",
        },
      ],
    };
  },
  props: {
    checklistDialog: Boolean,
  },
  computed: {
    programme() {
      return this.$store.getters["Application/appGetters"](
        "setupProgrammes",
      ).filter((item) => item.code === this.application["programme"])[0];
    },
    application() {
      return this.$store.getters["Application/appGetters"]("application");
    },
    setChecklistDialog: {
      get() {
        return this.checklistDialog;
      },
      set(val) {
        this.$emit("close-dialog", val);
      },
    },
  },
};
</script>

<style>
.font {
  font-family: "PT Sans Caption", sans-serif;
}
</style>
